<template>
  <v-row>
    <v-col cols="12" md="6">
      <gg-card-title class="pb-0 pt-0">Manage Your Websites</gg-card-title>
    </v-col>

    <v-col cols="12">
      <WebsitesGroupController
        :collapsed="collapsedAll"
        title="My Websites"
        @collapse-all="handleCollapseAll"
        @search="handleSearch"
        :websites-count="filteredWebsites.length"
      >
        <template v-slot:filter>
          <g-g-filter
            offset-y
            left
            bottom
            :close-on-content-click="false"
            :items="filterItems"
            @change="filters = $event"
          >
            <template v-slot:button-prepend>
              <v-icon size="18">mdi-filter-outline</v-icon>
            </template>
          </g-g-filter>
        </template>
      </WebsitesGroupController>
    </v-col>

    <v-col v-for="group in filteredGroupedWebsites" :key="group.key" cols="12">
      <WebsitesGroupTable
        :items="group.items"
        :group-name="group.name"
        :service-id="group.serviceId"
        :is-active="group.status === 'Active'"
        :collapsed="getGroupCollapsed(group.key)"
        @collapse="handleGroupCollapse(group.key)"
      ></WebsitesGroupTable>
    </v-col>

    <!-- <v-col cols="12">
      <WebsitesListTable
        :items="websites"
        :loading="isLoading"
        :filters="filters"
        :search="search"
        :key="websites.length"
      >
        <template v-slot:header-actions>
          <g-g-filter
            offset-y
            left
            bottom
            :close-on-content-click="false"
            :items="filterItems"
            @change="filters = $event"
          ></g-g-filter>
          <div class="w-100" style="max-width: 440px">
            <ServicesSearch compact v-model="search"></ServicesSearch>
          </div>
        </template>
      </WebsitesListTable>
    </v-col> -->
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import WebsitesListTable from '@/components/Websites/WebsitesListTable'
import WebsitesGroupController from '@/components/Websites/WebsitesGroupController'
import WebsitesGroupTable from '@/components/Websites/WebsitesGroupTable'
// import ServicesSearch from '@/components/Services/Hosting/ServicesPage/ServicesSearch'
import GGFilter from '@/components/Elements/GGFilter'
import { SERVICE_TYPES } from '@/consts/service'

export default {
  name: 'WebsitesList',
  components: {
    // ServicesSearch,
    // WebsitesListTable,
    GGFilter,
    WebsitesGroupController,
    WebsitesGroupTable,
  },

  data () {
    return {
      search: '',
      groupSearch: '',
      // filter definitions mirrored from WebsitesListTable
      filterItems: [
        {
          group: 'hosting',
          label: 'Hosting Plan',
          items: [
            { value: 'cpanel', label: 'Shared' },
            { value: 'whm', label: 'Reseller' },
            { value: 'vserver', label: 'VPS' },
            { value: 'dserver', label: 'Dedicated' },
          ],
        },
        {
          group: 'domain',
          label: 'Domain Type',
          items: [
            { value: 'main', label: 'Main Domain' },
            { value: 'addon', label: 'Addon' },
            { value: 'parked', label: 'Parked' },
            { value: 'sub', label: 'Subdomain' },
          ],
        },
      ],
      // active filters to pass into WebsitesListTable
      filters: [],
      collapsedAll: false,
      collapsedGroups: {},
    }
  },

  computed: {
    ...mapGetters({
      services: 'services',
      getWebsites: 'getWebsites',
      websitesStatus: 'websitesStatus',
    }),
    isLoading () {
      return this.websitesStatus === 'loading'
    },
    groupedWebsites () {
      const groups = {}
      this.websites.forEach((website) => {
        const hostingPlan = website.hostingPlan || 'No Hosting'
        if (!groups[hostingPlan]) {
          groups[hostingPlan] = []
        }
        groups[hostingPlan].push(website)
      })
      return groups
    },
    filteredWebsites () {
      let filtered = this.websites

      // apply search
      if (this.groupSearch) {
        const searchLower = this.groupSearch.toLowerCase()
        filtered = filtered.filter((website) => {
          return (
            (website.domain && website.domain.toLowerCase().includes(searchLower)) ||
            (website.mainDomain && website.mainDomain.toLowerCase().includes(searchLower))
          )
        })
      }

      // apply filters
      if (this.filters.length) {
        filtered = this.applyFilters(filtered, this.filters)
      }

      return filtered
    },
    // one group per hosting service, so each card is one plan and "Manage Plan" knows where to go;
    // a Map keeps the websites' order (numeric-looking object keys would get re-sorted)
    filteredGroupedWebsites () {
      const groups = new Map()

      this.filteredWebsites.forEach((website) => {
        const key = String(website.serviceId)
        if (!groups.has(key)) {
          const isSharedLabel = website.sharedaccount ? ' (Shared With Me)' : ''
          groups.set(key, {
            key,
            serviceId: website.serviceId,
            status: website.status,
            name: (website.hostingPlan || 'No Hosting') + isSharedLabel,
            items: [],
          })
        }
        groups.get(key).items.push(website)
      })
      return Array.from(groups.values())
    },
    websites () {
      const websites = this.getWebsites.slice()
      const usedIds = new Set()
      websites.forEach((website) => {
        website.serviceId = website.service_id
        const service = this.services.find((item) => item.id == website.service_id)
        if (service) {
          usedIds.add(service.id)
          website.status = service.status
          website.mainDomain = service.domain
          website.hostingPlan = service.name
          website.type = service.type
          website.flag = service.flag
          website.sharedaccount = service.sharedaccount
          website.sharedaccess = service.sharedaccess
          if (service.domain !== website.domain && website.domaintype === 'main') {
            website.user = website.username
          }
        }
      })
      const servicesNotUsed = this.services.filter((service) => {
        return !usedIds.has(service.id) && !service.related_service && service.type !== SERVICE_TYPES.OTHER
      })
      servicesNotUsed.forEach((service) => {
        websites.push({
          serviceId: service.id,
          domain: service.domain,
          status: service.status,
          mainDomain: service.domain,
          hostingPlan: service.name,
          type: service.type,
          flag: service.flag,
          domaintype: 'main',
          sharedaccount: service.sharedaccount,
          sharedaccess: service.sharedaccess,
        })
      })
      return websites
    },
  },

  methods: {
    ...mapActions({
      reportError: 'reportError',
      loadWebsites: 'loadWebsites',
      clearWebsites: 'clearWebsites',
      loadDatesForDomains: 'loadDatesForDomains',
    }),
    async fetchWebsites () {
      this.clearWebsites()
      try {
        await this.loadWebsites()
      } catch (e) {
        this.reportError(e)
      }
    },
    handleGroupCollapse (groupName) {
      if (this.collapsedAll) {
        this.collapsedAll = false
        this.filteredGroupedWebsites.forEach(({ key }) => {
          this.$set(this.collapsedGroups, key, key !== groupName)
        })
      } else {
        this.$set(this.collapsedGroups, groupName, !this.collapsedGroups[groupName])
      }
    },
    handleCollapseAll (collapsed) {
      this.collapsedAll = collapsed
      if (collapsed) {
        this.collapsedGroups = {}
      }
    },
    handleSearch (searchQuery) {
      this.groupSearch = searchQuery
    },
    getGroupCollapsed (groupName) {
      if (this.collapsedAll) {
        return true
      }
      return !!this.collapsedGroups[groupName]
    },
    applyFilters (websites, filters) {
      if (!filters.length) {
        return websites
      }

      const hostingFilters = this.filterItems
        .find((filterGroup) => filterGroup.group === 'hosting')
        .items.map((item) => item.value)
        .filter((type) => filters.includes(type))

      const domainFilters = this.filterItems
        .find((filterGroup) => filterGroup.group === 'domain')
        .items.map((item) => item.value)
        .filter((type) => filters.includes(type))

      let filtered = websites

      if (hostingFilters.length) {
        filtered = filtered.filter((website) => {
          return hostingFilters.includes(website.type)
        })
      }

      if (domainFilters.length) {
        filtered = filtered.filter((website) => {
          return domainFilters.includes(website.domaintype)
        })
      }

      return filtered
    },
  },

  mounted () {
    this.fetchWebsites()
  },
}
</script>

<style scoped>
</style>
